
import {
  defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import { useGradeBase } from '@/core/composables/GradeBase';
import { useTelaBase } from '@/core/composables/TelaBase';
import { IPagination } from '@/core/models/AntDesign/IPagination';
import { IListaPaginadaMetaData } from '@/core/models/Consulta/IListaPaginada';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import Icone from '@/core/components/Icone.vue';
import Card from '@/core/components/Tela/Card.vue';
import SelecionarModeloDocumentoFiscal from '@/components/Compartilhados/SelecionarModeloDocumentoFiscal.vue';
import SelecionarPessoa from '@/components/Cadastros/Pessoas/SelecionarPessoa.vue';
import { IFiltroRelatorioNotasFiscais } from '@/models/Relatorios/Fiscal/IFiltroRelatorioNotasFiscais';
import { IDadosRelatorioNotasFiscais } from '@/models/Relatorios/Fiscal/IDadosRelatorioNotasFiscais';
import { IDTONotaFiscal } from '@/models/DTO/Fiscal/NotasFiscais/IDTONotaFiscal';
import ServicoNotaFiscal from '@/servicos/Fiscal/ServicoNotaFiscal';
import SelecionarTipoOperacao from '@/components/Cadastros/SelecionarTipoOperacao.vue';
import SelecionarStatusNotaFiscal from '@/components/Relatorios/Fiscal/SelecionarStatusNotaFiscal.vue';

export default defineComponent({
  name: 'RelatorioNotasEmitidas',
  components: {
    TituloPadrao,
    Icone,
    Card,
    SelecionarModeloDocumentoFiscal,
    SelecionarDataInicialFinal,
    SelecionarPessoa,
    PreviewPdf,
    SelecionarTipoOperacao,
    SelecionarStatusNotaFiscal,
  },
  setup(props) {
    const servicoSistema = new ServicoSistema();
    const servicoNotaFiscal = new ServicoNotaFiscal();
    const {
      telaBase, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemAlerta, apresentarMensagemErro,
      preencherEmpresasDisponiveis, verificaConceitoParaApresentarEmpresas, defineEmpresasSelecionadasComPermissao,
      preencherDadosRota,
    } = useTelaBase();
    const { gradeBase } = useGradeBase();
    const state = reactive({
      dataInicial: '01/01/2001',
      dataFinal: '10/01/2001',
      filtros: {} as IFiltroRelatorioNotasFiscais,
      filtrosUtilizados: {} as IFiltroRelatorioNotasFiscais,
      resultado: {} as IDadosRelatorioNotasFiscais,
      itens: [] as IDTONotaFiscal[],
      paginacao: {} as IPagination,
      paginacaoAPI: { totalRegistros: 0, paginaAtual: 1 } as IListaPaginadaMetaData,
      timerRegistros: 0,
      totalRegistrosComMascara: '100',
      arquivoPdf: [] as IArquivoPdf[],
      mostrarFiltrosInteligentes: 1,
      mostrarFiltros: 0,
      mostrarItens: false,
      cacheAutomatico: {} as ISalvamentoAutomatico,
    });
    telaBase.apresentarEmpresas = false;

    function preencherColunas() {
      if (storeSistema.state.layoutMobile) {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'Numero', key: 'Item', position: 1, visible: false,
          },
        ];
      } else {
        gradeBase.colunas = [
          {
            title: 'Numero', dataIndex: 'numero', key: 'Numero', position: 1, visible: true, align: 'left', width: 100,
          },
          {
            title: 'Modelo', dataIndex: 'modelo', key: 'Modelo', position: 2, visible: true, align: 'center', width: 100,
          },
          {
            title: 'Status', dataIndex: 'status', key: 'status', position: 3, visible: true, align: 'left', width: 120,
          },
          {
            title: 'Data de Emissão', dataIndex: 'dataEmissao', key: 'DataEmissao', position: 3, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararData, width: 175,
          },
          {
            title: 'Razão Social/Nome', dataIndex: 'nomeRazaoSocialDestinatario', key: 'RazaoSocialNome', position: 4, visible: true, align: 'left', width: 300,
          },
          {
            title: 'CPF/CNPJ', dataIndex: 'cpfCnpjFormatado', key: 'CpfCnpjParticipante', position: 5, visible: true, align: 'left', width: 175,
          },
          {
            title: 'Natureza da Operação', dataIndex: 'naturezaOperacao', key: 'NaturezaOperacao', position: 6, visible: true, align: 'left', width: 300,
          },
          {
            title: 'ICMS', dataIndex: 'valorIcms', key: 'ValorTotalIcms', position: 7, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararFracionado, width: 150,
          },
          {
            title: 'IPI', dataIndex: 'valorTotalIpi', key: 'ValorTotalIPI', position: 8, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararFracionado, width: 150,
          },
          {
            title: 'PIS', dataIndex: 'valorTotalPis', key: 'ValorTotalPis', position: 9, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararFracionado, width: 150,
          },
          {
            title: 'COFINS', dataIndex: 'valorTotalCofins', key: 'ValorTotalCofins', position: 9, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararFracionado, width: 150,
          },
          {
            title: 'Total', dataIndex: 'totalNotaFiscal', key: 'ValorTotal', position: 9, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararFracionado, width: 150,
          },
        ];
      }
    }

    function obterIdentificadorCache(): string {
      return `RELATORIO_NOTAS_EMITIDAS_${storeSistema.getters.codigoUsuarioAutenticado()}`;
    }

    function salvarCache() {
      const identificador = obterIdentificadorCache();
      state.cacheAutomatico.data = UtilitarioData.obterDataAtual();
      state.cacheAutomatico.codigoEmpresa = state.filtros.empresa;
      state.cacheAutomatico.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
      state.cacheAutomatico.identificador = telaBase.identificadorRecurso;
      state.cacheAutomatico.dados = JSON.stringify(state.filtros);
      servicoSistema.salvamentoAutomaticoLocalStorage(`${identificador}`, state.cacheAutomatico);
    }

    async function buscarRelatorio() {
      telaBase.carregando = true;
      state.filtros.dataInicial = state.dataInicial;
      state.filtros.dataFinal = state.dataFinal;
      state.filtros.numeroPagina = state.paginacao.current;
      state.filtros.qtdRegistrosPagina = state.paginacao.pageSize;
      state.filtros.qtdTotalRegistros = state.paginacao.total;
      state.resultado = await servicoNotaFiscal.obterNotaFiscal(state.filtros);
      state.filtrosUtilizados = UtilitarioGeral.clonarObjeto(state.filtros);
      salvarCache();
      preencherColunas();
      state.mostrarItens = true;
      state.itens = state.resultado.itens.dados;
      state.paginacaoAPI = state.resultado.itens.metaData;
      state.mostrarFiltros = 0;
      state.mostrarFiltrosInteligentes = 0;
      telaBase.carregando = false;
    }

    async function alterarQuantidadeRegistroTotal(valor: any) {
      clearTimeout(state.timerRegistros);
      let totalRegistros = 100;
      state.timerRegistros = setTimeout(async () => {
        if (UtilitarioGeral.valorValido(valor)) {
          const limiteRegistros = UtilitarioMascara.removerMascaraNumero(valor);
          if (limiteRegistros > 0) {
            totalRegistros = limiteRegistros;
          }
        }
        state.paginacao.total = totalRegistros;
        state.totalRegistrosComMascara = UtilitarioMascara.mascararNumeroInteiro(totalRegistros);
        await buscarRelatorio();
      }, 600);
    }

    function obterDescricaoStatus(status: number) {
      switch (status) {
        case 1:
          return 'Autorizada';
        case 2:
          return 'Cancelada';
        case 3:
          return 'Devolução';
        case 4:
          return 'Nota Complementar';
        case 5:
          return 'Nota Ajuste';
        default:
          return '';
      }
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo) {
      telaBase.carregando = true;
      if (!UtilitarioGeral.validaLista(state.itens)) {
        await buscarRelatorio();
      }
      const retornoRelatorio = await servicoNotaFiscal.obterArquivoNotaFiscal(tipoArquivoRelatorio, state.filtrosUtilizados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivoPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.filtros.empresa);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarRelatorio();
    }

    function usarFiltroInteligente(filtro: number) {
      switch (filtro) {
        case 2:
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, -3);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 0);
          state.filtros.modeloNota = '55';
          break;
        case 3:
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, 0);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 0);
          state.filtros.modeloNota = '65';
          break;
        default:
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, 0);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 0);
          break;
      }
      buscarRelatorio();
    }

    function limparFiltros() {
      state.filtros = {} as IFiltroRelatorioNotasFiscais;
      state.filtros.empresa = storeSistema.getters.codigoEmpresaOperacao();
      state.filtros.modeloNota = '';
      state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
      state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
    }

    async function onPageChange(current: number, pageSize: number) {
      state.paginacao.current = current;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    async function onShowSizeChange(current: number, pageSize: number) {
      state.paginacao.current = 1;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    watch(() => storeSistema.state.layoutMobile, () => {
      preencherColunas();
    });

    onBeforeMount(async () => {
      preencherDadosRota();
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      verificaConceitoParaApresentarEmpresas();
      preencherColunas();
      limparFiltros();
      state.paginacao.total = 100;
      state.paginacao.showSizeChanger = true;
      state.paginacao.pageSize = 100;
      state.paginacao.current = 1;
      state.paginacao.pageSizeOptions = ['10', '50', '100', '500', '1000'];
    });

    return {
      state,
      props,
      window,
      ETipoArquivo,
      ECustomRenderRow,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioDispositivo,
      storeSistema,
      telaBase,
      gradeBase,
      limparFiltros,
      obterIdentificadorCache,
      salvarCache,
      buscarRelatorio,
      atualizarSelecaoEmpresas,
      usarFiltroInteligente,
      imprimir,
      alterarQuantidadeRegistroTotal,
      onPageChange,
      onShowSizeChange,
      obterDescricaoStatus,
    };
  },
});
